import { container } from 'tsyringe'
import { Color, Texture } from 'three'
import GlobalParticlesSystem, { Size, SpawnParticleOptions } from './global-particles-system'
import { Interface } from '@/shared/di/interface'
import type { IAssets } from '@/shared/di/interface/assets'

export interface GlobalParticlesOptions {
  maxParticles: number
  containerCount: number
  positionRandomness: number
  velocityRandomness: number
  sizeRandomness: number
  colorRandomness: number
  turbulence: number
  lifetime: number
  size: number
  smoothPosition: boolean
  opacity: number
  startTime: number
  color: Color
  trailId?: number
  particleNoiseTex?: Texture
  particleSpriteTex?: Texture
}

export default class GlobalParticlesManager {
  options: GlobalParticlesOptions
  particleSystem: GlobalParticlesSystem
  #time = 0
  type = 'default'

  constructor() {
    // defaults

    const assets = container.resolve<IAssets>(Interface.IAssets)

    this.options = {
      maxParticles: 200,
      containerCount: 1,
      positionRandomness: 0.3,
      velocityRandomness: 0.2,
      sizeRandomness: 0.4,
      colorRandomness: 0.0,
      turbulence: 0.0,
      lifetime: 4.0,
      size: 5,
      smoothPosition: true,
      opacity: 1,
      startTime: 0,
      color: new Color(0x884415),
      particleNoiseTex: assets.getTexture('perlin-512') as Texture,
      particleSpriteTex: assets.getTexture('particle') as Texture
    }

    this.particleSystem = new GlobalParticlesSystem(this.options)
    this.particleSystem.userData.isParticleSystem = true
  }

  spawnParticle(particleOptions: SpawnParticleOptions) {
    const finalOptions = Object.assign({}, this.options, particleOptions)
    finalOptions.startTime = this.#time
    this.particleSystem.spawnParticle(finalOptions)
  }

  update(time: number, delta: number) {
    this.#time = time
    this.particleSystem.update(time)
  }

  resize(size: Size) {
    this.particleSystem.resize(size)
  }

  dispose() {}
}
